<script setup lang="ts">
import { defineAsyncComponent, onBeforeUnmount, onMounted, ref } from "vue";
import { scheduleIdleTask } from "@/composables/useIdleTask";

const runtimeReady = ref(false);
let cancelIdle: (() => void) | undefined;
const AsyncVersionUpdateDialog = defineAsyncComponent(() => import("@/components/VersionUpdateDialog/index.vue"));
const AsyncToaster = defineAsyncComponent(() => import("vue-sonner").then(({ Toaster }) => Toaster));

onMounted(() => {
  cancelIdle = scheduleIdleTask(() => { runtimeReady.value = true; }, { timeout: 8000 });
});
onBeforeUnmount(() => cancelIdle?.());
</script>

<template>
  <template v-if="runtimeReady">
    <AsyncVersionUpdateDialog />
    <AsyncToaster position="top-center" :toast-options="{ style: { background: '#1a1208', color: '#f5f0e8', border: '1px solid rgba(184,134,11,0.3)' } }" />
  </template>
</template>
